export const ignoredPattern = [
    'date',
    'highlight',
    'time',
    'age',
    'day',
    'date_hour',
    'type',
    'count_posts',
    'month',
    'week',
    'organic',
    'paid',
    'percentage_male',
    'percentage_female',
    'evolution'
];
